import { FEATURE_FLAGS } from '../constants';
import featureFlags from './featureFlags';
import { DEFAULT_PROJECT_TIMEZONE } from './date-helpers';
import { Rfi } from '../sdk';

export const getDueDateTimeZone = (
  rfiCreatedAt: Rfi['createdAt'],
  projectTimeZone?: string | null,
): string | undefined => {
  const timestampToShowDueDateInProjectTimezoneFrom = featureFlags.get(
    FEATURE_FLAGS.RFIS_FE_DUE_DATE_TO_APPLY_PROJECT_TZ_FROM,
  );

  const createdAtTimestamp = new Date(rfiCreatedAt).getTime();
  const shouldShowDueDateInProjectTimezone =
    createdAtTimestamp - timestampToShowDueDateInProjectTimezoneFrom > 0;

  const dueDateTimeZone = shouldShowDueDateInProjectTimezone
    ? projectTimeZone || DEFAULT_PROJECT_TIMEZONE
    : undefined;

  return dueDateTimeZone;
};
